import percent from './percent'
import number from './number'
import currency from './currency'

export default params => {
  switch(params.format) {
    case 'percent':
      return percent(params);
    case 'number':
      return number(params);
    case 'currency':
      return currency(params);
    default:
      return number(params);
    }
}
